import LanguageSelector from "../components/LanguajeSelector.jsx";
import MapView from "../components/Map";
import MapLegend from "../components/mapRelated/MapLeyends.jsx";
import MenuWrapper from "../components/menu/MenuWrapper.jsx";
import Modal from "../components/Modal.jsx";
import { ModalProvider } from "../context/ModalContext.jsx";
export default function IndexPage() {
  return (
    <ModalProvider>
      <div className="relative h-dvh w-screen block overflow-hidden">
        <Modal />
        <LanguageSelector />
        <MapView />
        <MapLegend />
        <MenuWrapper />
      </div>
    </ModalProvider>
  );
}
